import { render, staticRenderFns } from "./calender.vue?vue&type=template&id=bcb1d1b0&scoped=true&"
import script from "./calender.vue?vue&type=script&lang=js&"
export * from "./calender.vue?vue&type=script&lang=js&"
import style0 from "./calender.vue?vue&type=style&index=0&id=bcb1d1b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb1d1b0",
  null
  
)

export default component.exports